<img src="../../../../assets/images/logo.svg" alt="logo" class="footer-logo" />
<div class="copyright">Copyright © 2021 Xos Trucks. All Rights Reserved.</div>
